<template>
  <div>
    <div class="web">
      <div class="bannerPart" v-if="bannerlist.length > 0">
        <!-- Swiper 容器 -->
        <div class="swiper-container_pc">
          <div class="swiper-wrapper">
            <!-- 幻灯片内容 -->
            <div
              class="swiper-slide"
              v-for="(item, index) in bannerlist"
              :key="index"
            >
              <div class="swiper-banner" @click="bannerClick(item)">
                <img :src="item.banner_url" alt="" />
                <div class="banner-blog">
                  <div class="banner-blog-title">{{ item.title }}</div>
                  <div class="banner-blog-content">{{ item.describe }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
        <div class="swiper-container_pc_1440">
          <div class="swiper-wrapper">
            <!-- 幻灯片内容 -->
            <div
              class="swiper-slide"
              v-for="(item, index) in bannerlist"
              :key="index"
            >
              <div class="swiper-banner" @click="bannerClick(item)">
                <img :src="item.banner_url" alt="" />
                <div class="banner-blog">
                  <div class="banner-blog-title">{{ item.title }}</div>
                  <div class="banner-blog-content">{{ item.describe }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
      <div class="blog-moudle">
        <div class="title">All Blog</div>
        <div class="title-ch">所有文章</div>
        <div class="card-container">
          <div
            v-for="(item, index) in isExpanded
              ? cardsList
              : cardsList.slice(0, 12)"
            :key="index"
            class="card cursor"
            @click="bannerClick(item)"
          >
            <div class="card-top">
              <img class="card-img" :src="item.list_url" />
              <div class="card-title">{{ item.title }}</div>
            </div>
            <div class="card-bottom">
              <div class="card-date">{{ item.release_time }}</div>
              <div
                class="card-btn"
                v-if="item.link_url && item.link_url.includes('http')"
              >
                阅读
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="cardsList.length > 12 && !isExpanded"
          class="expand-button"
          @click="isExpanded = true"
          @mouseenter="changeColor"
          @mouseleave="resetColor"
        >
          <span>展开</span>
          <img
            :src="
              mouseEnter
                ? `${httpImg}/zhankai-white.png`
                : `${httpImg}/zhankai.png`
            "
            alt=""
          />
        </div>
        <div
          v-if="cardsList.length > 12 && isExpanded"
          @click="isExpanded = false"
          class="expand-button"
          @mouseenter="changeColor"
          @mouseleave="resetColor"
        >
          <span>收起</span>
          <img
            :src="
              mouseEnter
                ? `${httpImg}/shouqi-white.png`
                : `${httpImg}/shouqi.png`
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="bannerPart" v-if="bannerlist.length > 0">
        <!-- Swiper 容器 -->
        <div class="swiper-container_m">
          <div class="swiper-wrapper">
            <!-- 幻灯片内容 -->
            <div
              class="swiper-slide"
              v-for="(item, index) in bannerlist"
              :key="index"
            >
              <div class="swiper-banner" @click="bannerClick(item)">
                <img :src="item.banner_url" alt="" />
                <div class="banner-blog">
                  <div class="banner-blog-title">{{ item.title }}</div>
                  <div class="banner-blog-content">{{ item.describe }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="swiper-pagination" v-if="bannerlist.length>1"></div> -->
          <div class="swiper-pagination"></div>
        </div>

        <!-- 768 -->
        <div class="swiper-container_m_768">
          <div class="swiper-wrapper">
            <!-- 幻灯片内容 -->
            <div
              class="swiper-slide"
              v-for="(item, index) in bannerlist"
              :key="index"
            >
              <div class="swiper-banner" @click="bannerClick(item)">
                <img :src="item.banner_url" alt="" />
                <div class="banner-blog">
                  <div class="banner-blog-title">{{ item.title }}</div>
                  <div class="banner-blog-content">{{ item.describe }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="swiper-pagination" v-if="bannerlist.length>1"></div> -->
          <div class="swiper-pagination"></div>

          <div class="swiper-button-next"></div>
          <div class="swiper-button-prev"></div>
        </div>
      </div>
      <div class="topPos" v-if="bannerlist.length == 0"></div>
      <div class="blog-moudle">
        <div class="title">All Blog</div>
        <div class="title-ch">所有文章</div>
        <div class="card-container">
          <div
            v-for="(item, index) in isH5Expanded
              ? cardsList
              : cardsList.slice(0, 6)"
            :key="index"
            class="card"
            @click="bannerClick(item)"
          >
            <div class="card-top">
              <img class="card-img" :src="item.img_url" />
              <div class="card-title">{{ item.title }}</div>
            </div>
            <div class="card-bottom">
              <div class="card-date">{{ item.release_time }}</div>
              <div
                class="card-btn cursor"
                v-if="item.link_url && item.link_url.includes('http')"
              >
                阅读
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="cardsList.length > 6 && !isH5Expanded"
          class="expand-button"
          @click="isH5Expanded = true"
        >
          <span>展开</span>
          <img :src="`${httpImg}/zhankai.png`" alt="" />
        </div>
        <div
          v-if="cardsList.length > 12 && isH5Expanded"
          @click="isH5Expanded = false"
          class="expand-button"
        >
          <span>收起</span>
          <img :src="`${httpImg}/shouqi.png`" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "blog",
  components: {},
  data: () => ({
    httpImg:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/solution",
    cardsList: [],
    isExpanded: false,
    isH5Expanded: false,
    mouseEnter: false,
    bannerlist: [],
  }),
  mounted() {
    this.getArticleList();
    this.getBannerlist();
  },
  methods: {
    getArticleList() {
      this.$ajax
        .post(this.API.api.apiurl.getArticleList, {}, {})
        .then((res) => {
          res.data.data.forEach((item) => {
            item.release_time = item.release_time.replace(/\//g, "-");
          });
          let showArr = res.data.data.filter((x) => {
            // console.log(x.show_position)
            return Array.isArray(x.show_position) && x.show_position.length > 0;
          });
          this.cardsList = showArr;
          // this.cardsList = [...showArr, ...showArr, ...showArr, ...showArr];
          // console.log("文章列表返回值-------", this.cardsList);
          if (this.cardsList.length > 12) {
            this.isExpanded = false;
          } else {
            this.isExpanded = true;
          }

          if (this.cardsList.length > 6) {
            this.isH5Expanded = false;
          } else {
            this.isH5Expanded = true;
          }
        });
    },
    getBannerlist() {
      this.$ajax
        .post(this.API.api.apiurl.getArticleList, {
          show_position: 2,
        })
        .then((res) => {
          res.data.data.forEach((item) => {
            item.release_time = item.release_time.replace(/\//g, "-");
          });
          let list = res.data.data.filter((item) => item.banner_url);
          this.bannerlist = list;
          console.log("顶部轮播列表返回值-------------", this.bannerlist, list);

          setTimeout(function () {
            new Swiper(".swiper-container_pc", {
              // 启用自动播放
              autoplay: {
                delay: 3000, // 幻灯片切换间隔时间（毫秒）
                disableOnInteraction: false, // 用户操作后是否停止自动播放
              },
              speed: 800, // 切换动画速度（毫秒）
              slidesPerView: 1.42, // 每个视图显示 1.5 个滑块
              spaceBetween: 90, // 滑块之间的间隙
              centeredSlides: true, // 活动块居中
              loop: true, // 循环模式
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },

              effect: "coverflow", // 使用 coverflow 效果
              // grabCursor: true,
              coverflowEffect: {
                rotate: 0, // 滑块的旋转角度
                stretch: 0, // 滑块的拉伸值
                depth: 100, // 滑块的深度
                modifier: 1, // 缩放比例
                slideShadows: false, // 是否显示阴影
              },
            });
            new Swiper(".swiper-container_pc_1440", {
              // 启用自动播放
              autoplay: {
                delay: 3000, // 幻灯片切换间隔时间（毫秒）
                disableOnInteraction: false, // 用户操作后是否停止自动播放
              },
              speed: 800, // 切换动画速度（毫秒）
              slidesPerView: 1.15, // 每个视图显示 1.5 个滑块
              spaceBetween: 75, // 滑块之间的间隙
              centeredSlides: true, // 活动块居中
              loop: true, // 循环模式
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },

              effect: "coverflow", // 使用 coverflow 效果
              // grabCursor: true,
              coverflowEffect: {
                rotate: 0, // 滑块的旋转角度
                stretch: 0, // 滑块的拉伸值
                depth: 100, // 滑块的深度
                modifier: 1, // 缩放比例
                slideShadows: false, // 是否显示阴影
              },
            });

            new Swiper(".swiper-container_m", {
              // 启用自动播放
              autoplay: {
                delay: 3000, // 幻灯片切换间隔时间（毫秒）
                disableOnInteraction: false, // 用户操作后是否停止自动播放
              },
              speed: 800, // 切换动画速度（毫秒）
              slidesPerView: 1.12, // 每个视图显示 1.5 个滑块
              spaceBetween: 40, // 滑块之间的间隙
              centeredSlides: true, // 活动块居中
              loop: true, // 循环模式
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
                // bulletClass: "custom-bullet",
                // bulletActiveClass: "custom-bullet-active",
              },
              //   navigation: {
              //     nextEl: ".swiper-button-next",
              //     prevEl: ".swiper-button-prev",
              //   },

              effect: "coverflow", // 使用 coverflow 效果
              // grabCursor: true,
              coverflowEffect: {
                rotate: 0, // 滑块的旋转角度
                stretch: 0, // 滑块的拉伸值
                depth: 150, // 滑块的深度
                modifier: 1, // 缩放比例
                slideShadows: false, // 是否显示阴影
              },
            });

            // 768
            new Swiper(".swiper-container_m_768", {
              // 启用自动播放
              autoplay: {
                delay: 3000, // 幻灯片切换间隔时间（毫秒）
                disableOnInteraction: false, // 用户操作后是否停止自动播放
              },
              speed: 800, // 切换动画速度（毫秒）
              slidesPerView: 1.15, // 每个视图显示 1.5 个滑块
              spaceBetween: 45, // 滑块之间的间隙
              centeredSlides: true, // 活动块居中
              loop: true, // 循环模式
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
                // bulletClass: "custom-bullet",
                // bulletActiveClass: "custom-bullet-active",
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },

              effect: "coverflow", // 使用 coverflow 效果
              // grabCursor: true,
              coverflowEffect: {
                rotate: 0, // 滑块的旋转角度
                stretch: 0, // 滑块的拉伸值
                depth: 100, // 滑块的深度
                modifier: 1, // 缩放比例
                slideShadows: false, // 是否显示阴影
              },
            });
          }, 0);
          console.log("bannerlist", this.bannerlist);
        });
    },
    changeColor() {
      this.mouseEnter = true;
    },
    resetColor() {
      this.mouseEnter = false;
    },
    bannerClick(item) {
      console.log("linkUrl", item);
      if (!item.link_url || !item.link_url.includes("http")) {
        return;
      } else {
        window.open(item.link_url, "_blank");
        // this.$router.push({
        //   name: "blogDetail",
        //   params: {
        //     url:item.link_url,
        //   },
        // });
      }
    },
  },
};
</script>
<style>
.swiper-pagination-bullet-active {
  background: #000000 !important;
}
</style>
<style scoped lang="scss">
// mobile414
@media screen and (max-width: 767px) {
  .web {
    display: none;
  }
  .mobile {
    overflow-y: scroll;
    overflow-x: hidden;
    .topPos {
      height: 1.38rem;
    }
  }
  .bannerPart {
    background-color: white;
    .swiper-container_pc {
      display: none;
    }
    .swiper-container_m {
      padding-top: 2.35rem;
      padding-bottom: 2.13rem;
      position: relative;
      .swiper-wrapper {
        .swiper-slide {
          //   height: 7.33rem;
          .swiper-banner {
            position: relative;
            img {
              width: 100%;
              //   height: auto;
              height: 7.33rem;
              border-radius: 0.1932rem;
              object-fit: cover;
            }
            .banner-blog {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              min-height: 2.56rem;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: center;
              padding: 0.24rem 0.5rem 0.41rem 0.34rem;
              text-align: left;
              box-sizing: border-box;
              border-radius: 0.19rem;
              backdrop-filter: blur(15px);

              .banner-blog-title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 0.39rem;
                color: #ffffff;
                line-height: 0.68rem;
                text-align: left;
                font-style: normal;
              }

              .banner-blog-content {
                font-family: PingFangSC, PingFang SC;
                font-weight: 300;
                font-size: 0.29rem;
                color: #ffffff;
                line-height: 0.29rem;
                text-align: left;
                font-style: normal;
                white-space: nowrap; /* 禁止文本换行 */
                overflow: hidden; /* 隐藏超出容器的内容 */
                text-overflow: ellipsis; /* 超出部分显示为省略号 */
                width: 85%;
                margin-top: 0.27rem;
              }
            }
          }
        }
      }
      .swiper-pagination {
        position: absolute;
        bottom: 10%;
        left: 0;
      }
      .swiper-pagination-bullet-active {
        background: #000000 !important;
      }
      .custom-bullet {
        width: 0.19rem;
        height: 0.19rem;
        border-radius: 50%;
        background-color: #cbcbcb !important;
      }
      .custom-bullet-active {
        width: 0.19rem;
        height: 0.19rem;
        border-radius: 50%;

        background: #000000 !important;
      }
    }
    .swiper-container_m_768 {
      display: none;
    }
  }

  //   .swiper-moudle {
  //     width: 100%;
  //     height: 9.53rem;
  //     background: bisque;
  //     margin: 1.38rem 0 0 0;
  //   }

  .blog-moudle {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f6f4f1;
    padding: 1.45rem 0;
  }

  .title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.72rem;
    color: #141414;
    line-height: 0.85rem;
  }

  .title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.31rem;
    color: #000000;
    line-height: 0.43rem;
    margin: 0.12rem 0 0 0;
  }

  .card-container {
    display: grid;
    grid-template-columns: repeat(2, 4.28rem);
    gap: 0.29rem;
    justify-items: center;
    transition: max-height 0.3s ease;
    margin: 0.97rem 0 0 0;
    box-sizing: border-box;
  }

  .card {
    width: 4.28rem;
    height: 5.04rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 0.19rem 0.19rem 0.36rem;
    box-sizing: border-box;
    border-radius: 0.19rem;
  }

  .card-top {
    display: flex;
    flex-direction: column;
  }

  .card-img {
    width: 3.92rem;
    height: 2.65rem;
    object-fit: cover;
  }

  .card-title {
    font-family: PingFangSC, PingFang SC;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.29rem;
    color: #000000;
    line-height: 0.43rem;
    margin: 0.19rem 0 0 0;
    text-align: left;
  }

  .card-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .card-date {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.27rem;
    color: #333333;
    line-height: 0.39rem;
  }

  .card-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.03rem;
    height: 0.43rem;
    border-radius: 0.97rem;
    border: 0.01rem solid #000000;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.27rem;
    color: #141414;
  }

  .expand-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.97rem auto 0;
    width: 2.19rem;
    height: 0.77rem;
    border-radius: 0.97rem;
    border: 0.01rem solid #000000;
    background: transparent;
    cursor: pointer;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.31rem;
    color: #1a1a1a;
    line-height: 0.43rem;
  }

  .expand-button img {
    width: 0.22rem;
    height: auto;
    margin: 0 0 0 0.12rem;
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .web {
    display: none;
  }
  .mobile {
    overflow-y: scroll;
    overflow-x: hidden;
    .topPos {
      height: 1.38rem;
    }
  }
  .bannerPart {
    background-color: white;
    .swiper-container_pc {
      display: none;
    }
    .swiper-container_m_768 {
      padding-top: 3.64rem;
      padding-bottom: 2.17rem;
      position: relative;
      .swiper-wrapper {
        .swiper-slide {
          //   height: 7.33rem;
          .swiper-banner {
            position: relative;
            img {
              width: 100%;
              //   height: auto;
              height: 7.33rem;
              border-radius: 0.12rem;
              object-fit: cover;
            }
            .banner-blog {
              position: absolute;
              right: 0.67rem;
              bottom: 0.67rem;
              width: 7.37rem;

              min-height: 2.33rem;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: center;

              padding: 0.41rem 0.5rem 0.39rem 0.54rem;

              text-align: left;
              box-sizing: border-box;

              border-radius: 0.15rem;
              backdrop-filter: blur(15px);

              .banner-blog-title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 0.33rem;
                color: #ffffff;
                line-height: 0.52rem;

                text-align: left;
                font-style: normal;
              }

              .banner-blog-content {
                font-family: PingFangSC, PingFang SC;
                font-weight: 300;
                font-size: 0.26rem;
                color: #ffffff;
                line-height: 0.22rem;

                text-align: left;
                font-style: normal;
                white-space: nowrap; /* 禁止文本换行 */
                overflow: hidden; /* 隐藏超出容器的内容 */
                text-overflow: ellipsis; /* 超出部分显示为省略号 */
                width: 85%;
                margin-top: 0.28rem;
              }
            }
          }
        }
      }
      .swiper-pagination {
        position: absolute;
        bottom: 10%;
        left: 0;
      }
      .swiper-pagination-bullet-active {
        background: #000000 !important;
      }
      .custom-bullet {
        width: 0.19rem;
        height: 0.19rem;
        border-radius: 50%;
        background-color: #cbcbcb !important;
      }
      .custom-bullet-active {
        width: 0.19rem;
        height: 0.19rem;
        border-radius: 50%;

        background: #000000 !important;
      }

      .swiper-button-prev {
        position: absolute;
        top: 55%;
        left: 10%;
        width: 0.81rem;
        height: 0.81rem;
        background-color: #eceef2;
        border-radius: 50%;
      }
      .swiper-button-next {
        position: absolute;
        top: 55%;
        right: 10%;
        width: 0.81rem;
        height: 0.81rem;
        background-color: #eceef2;
        border-radius: 50%;
      }
      .swiper-button-next:after,
      .swiper-button-prev:after {
        color: rgba(0, 0, 0, 0.6);
        // width: 0.15rem;
        // height: 0.3rem;
        font-size: 20px;
        font-weight: 999;
      }
    }
    .swiper-container_m {
      display: none;
    }
  }

  //   .swiper-moudle {
  //     width: 100%;
  //     height: 9.53rem;
  //     background: bisque;
  //     margin: 1.38rem 0 0 0;
  //   }

  .blog-moudle {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f6f4f1;
    padding: 1.17rem 0;
  }

  .title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 0.96rem;
  }

  .title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;
    margin: 0.19rem 0 0 0;
  }

  .card-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.3rem;
    justify-items: center;
    transition: max-height 0.3s ease;
    margin: 1.13rem 0 0 0;
    box-sizing: border-box;
  }

  .card {
    width: 4rem;
    height: 4.74rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 0.15rem 0.15rem 0.35rem;

    box-sizing: border-box;
    border-radius: 0.15rem;
  }

  .card-top {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .card-img {
    width: 100%;
    height: 2.53rem;
    object-fit: cover;
    border-radius: 6px;
  }

  .card-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.26rem;
    color: #000000;
    line-height: 0.41rem;

    margin: 0.2rem 0 0 0;
    text-align: left;
  }

  .card-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .card-date {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.26rem;
    color: #333333;
    line-height: 0.37rem;
  }

  .card-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 0.98rem;
    height: 0.41rem;
    border-radius: 0.74rem;
    border: 0.02rem solid #000000;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.22rem;
    color: #141414;
    line-height: 0.31rem;
  }

  .expand-button {
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 1.11rem auto 0;

    width: 2.56rem;
    height: 0.89rem;
    border-radius: 0.74rem;
    border: 0.02rem solid #000000;
    background: transparent;

    cursor: pointer;

    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.3rem;
    color: #1a1a1a;
    line-height: 0.41rem;
  }

  .expand-button img {
    width: 0.22rem;
    height: auto;
    margin: 0 0 0 0.26rem;
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .mobile {
    display: none;
  }
  .bannerPart {
    padding-top: 0.83rem;
    padding-bottom: 2.22rem;
    .swiper-container_m {
      display: none;
    }
    
    .swiper-container_pc_1440 {
      position: relative;
      .swiper-wrapper {
        .swiper-slide {
          //   height: 7.33rem;
          .swiper-banner {
            position: relative;
            img {
              width: 100%;
              //   height: auto;
              height: 7.33rem;
              object-fit: cover;
              // border-radius: 0.1481rem;
            }
            .banner-blog {
              position: absolute;
              right: 0.67rem;
              bottom: 0.67rem;

              width: 7.37rem;
              padding: 0.41rem 0.5rem 0.39rem 0.54rem;
              text-align: left;
              box-sizing: border-box;
              border-radius: 0.15rem;
              backdrop-filter: blur(15px);
              .banner-blog-title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 0.33rem;
                color: #ffffff;
                line-height: 0.52rem;
              }

              .banner-blog-content {
                white-space: nowrap; /* 禁止文本换行 */
                overflow: hidden; /* 隐藏超出容器的内容 */
                text-overflow: ellipsis; /* 超出部分显示为省略号 */
                font-family: PingFangSC, PingFang SC;
                font-weight: 300;
                font-size: 0.26rem;
                color: #ffffff;
                line-height: 0.26rem;
                margin: 0.28rem 0 0 0;
              }
            }
          }
        }
      }
      .swiper-button-prev {
        position: absolute;
        top: 50%;
        left: 8%;
        width: 0.81rem;
        height: 0.81rem;
        background-color: #eceef2;
        border-radius: 50%;
      }
      .swiper-button-next {
        position: absolute;
        top: 50%;
        right: 8%;
        width: 0.81rem;
        height: 0.81rem;
        background-color: #eceef2;
        border-radius: 50%;
      }
      .swiper-button-next:after,
      .swiper-button-prev:after {
        color: rgba(0, 0, 0, 0.6);
        // width: 0.15rem;
        // height: 0.3rem;
        font-size: 20px;
        font-weight: 999;
      }
    }
    .swiper-container_pc {
      display: none;
    }
  }

  .blog-moudle {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    padding: 2.22rem 1.85rem;
    padding-bottom: 2.22rem;
    background: #f6f4f1;
  }

  .title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 0.96rem;
  }

  .title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;
    margin: 0.15rem 0 0 0;
  }

  .card-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.33rem 0.33rem;
    justify-items: center;
    transition: max-height 0.3s ease;

    margin: 1.84rem 0 0 0;
    box-sizing: border-box;
  }

  .card-container.expanded {
    max-height: none;
  }

  .card {
    width: 5.48rem;
    height: 6.46rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 0.22rem 0.22rem 0.46rem;
    box-sizing: border-box;
  }

  .expand-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1.48rem auto 0;
    width: 3.15rem;
    height: 1.11rem;
    border-radius: 0.74rem;
    border: 0.02rem solid #000000;
    background: transparent;
    cursor: pointer;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.33rem;
    color: #1a1a1a;
    line-height: 0.46rem;
  }

  .expand-button img {
    width: 0.28rem;
    height: auto;
    margin: 0 0 0 0.22rem;
  }

  .expand-button:hover {
    background: #c25e4d;
    border: 0.02rem solid #c25e4d;
    color: #ffffff;
  }

  .card-top {
    display: flex;
    flex-direction: column;
  }

  .card-img {
    width: 5.04rem;
    height: 3.43rem;
    object-fit: cover;
    border-radius: 8px;
  }

  .card-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.3rem;
    color: #000000;
    line-height: 0.46rem;
    margin: 0.41rem 0 0 0;
    text-align: left;
  }

  .card-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0.46rem 0 0 0;
  }

  .card-date {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.26rem;
    color: #333333;
    line-height: 0.37rem;
  }

  .card-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.33rem;
    height: 0.56rem;
    border-radius: 0.74rem;
    border: 0.02rem solid #000000;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.26rem;
    color: #141414;
  }
}
// 1920
@media screen and (min-width: 1920px) {
  .mobile {
    display: none;
  }
  .bannerPart {
    padding-top: 1.48rem;
    padding-bottom: 2.22rem;
    .swiper-container_m {
      display: none;
    }
    .swiper-container_pc {
      position: relative;
      .swiper-wrapper {
        .swiper-slide {
          //   height: 7.33rem;
          .swiper-banner {
            position: relative;
            img {
              width: 100%;
              //   height: auto;
              height: 7.33rem;
              object-fit: cover;
              // border-radius: 0.1481rem;
            }
            .banner-blog {
              position: absolute;
              right: 0.67rem;
              bottom: 0.67rem;
              width: 7.37rem;
              padding: 0.41rem 0.5rem 0.39rem 0.54rem;
              text-align: left;
              box-sizing: border-box;
              border-radius: 0.15rem;
              backdrop-filter: blur(15px);
              .banner-blog-title {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 0.33rem;
                color: #ffffff;
                line-height: 0.52rem;
              }

              .banner-blog-content {
                white-space: nowrap; /* 禁止文本换行 */
                overflow: hidden; /* 隐藏超出容器的内容 */
                text-overflow: ellipsis; /* 超出部分显示为省略号 */
                font-family: PingFangSC, PingFang SC;
                font-weight: 300;
                font-size: 0.26rem;
                color: #ffffff;
                line-height: 0.26rem;
                margin: 0.28rem 0 0 0;
              }
            }
          }
        }
      }
      .swiper-button-prev {
        position: absolute;
        top: 50%;
        left: 17%;
        width: 0.81rem;
        height: 0.81rem;
        background-color: #eceef2;
        border-radius: 50%;
      }
      .swiper-button-next {
        position: absolute;
        top: 50%;
        right: 17%;
        width: 0.81rem;
        height: 0.81rem;
        background-color: #eceef2;
        border-radius: 50%;
      }
      .swiper-button-next:after,
      .swiper-button-prev:after {
        color: rgba(0, 0, 0, 0.6);
        // width: 0.15rem;
        // height: 0.3rem;
        font-size: 20px;
        font-weight: 999;
      }
    }
    .swiper-container_pc_1440 {
      display: none;
    }
  }

  .blog-moudle {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2.22rem 4.81rem;
    background: #f6f4f1;
  }

  .title {
    font-family: MADEEvolveSans, MADEEvolveSans;
    font-weight: bold;
    font-size: 0.81rem;
    color: #1a1a1a;
    line-height: 0.96rem;
  }

  .title-ch {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.41rem;
    color: #333333;
    line-height: 0.56rem;
    margin: 0.15rem 0 0 0;
  }

  .card-container {
    display: grid;
    grid-template-columns: repeat(4, 6.46rem);
    gap: 0.56rem 0;
    justify-items: center;
    transition: max-height 0.3s ease;
    margin: 1.84rem 0 0 0;
    box-sizing: border-box;
  }

  .card-container.expanded {
    max-height: none;
  }

  .card {
    width: 5.48rem;
    height: 6.46rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 0.22rem 0.22rem 0.46rem;
    box-sizing: border-box;
  }

  .expand-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1.48rem auto 0;
    width: 3.15rem;
    height: 1.11rem;
    border-radius: 0.74rem;
    border: 0.02rem solid #000000;
    background: transparent;
    cursor: pointer;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.33rem;
    color: #1a1a1a;
    line-height: 0.46rem;
  }

  .expand-button img {
    width: 0.28rem;
    height: auto;
    margin: 0 0 0 0.22rem;
  }

  .expand-button:hover {
    background: #c25e4d;
    border: 0.02rem solid #c25e4d;
    color: #ffffff;
  }

  .card-top {
    display: flex;
    flex-direction: column;
  }

  .card-img {
    width: 5.04rem;
    height: 3.43rem;
    object-fit: cover;
  }

  .card-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 0.3rem;
    color: #000000;
    line-height: 0.46rem;
    margin: 0.41rem 0 0 0;
    text-align: left;
  }

  .card-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0.46rem 0 0 0;
  }

  .card-date {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.26rem;
    color: #333333;
    line-height: 0.37rem;
  }

  .card-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.33rem;
    height: 0.56rem;
    border-radius: 0.74rem;
    border: 0.02rem solid #000000;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 0.26rem;
    color: #141414;
  }
}
</style>
